// axiosInstance.js
import axios from 'axios';
import keycloak from './../src/common/Keycloak';
import CryptoJS from 'crypto-js';

// Create an Axios instance with default configurations
const axiosInstance = axios.create({
    baseURL: (process.env.NODE_ENV === 'production') ? 'https://lastmileallocationpod-api.xbees.in/' : 'https://lastmileallocationpod-apistage.xbees.in/',
    responseType: 'json',
    timeout: 20000, // Optional: Set a timeout for requests
});

// Optionally add an interceptor to set headers dynamically
if (keycloak.enableKavach) {
    axiosInstance.interceptors.request.use(
        config => {
            let userToken = window.localStorage.getItem('lmUserToken')
            let token = userToken ? userToken.replace(/"/g, '') : false;
            if (token) {
                config.headers['x-auth-type'] = `lm-kavach-web`; // Set the Authorization header
                config.headers.Authorization = `Bearer ${token}`; // Set the Authorization header

                let userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
                let userDataKey = window.localStorage.getItem('userUniqueKey')
                if (userdetailEncrypt && userDataKey) {
                    let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), userDataKey);
                    let plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    let userdetail = JSON.parse(plaintext);
                    config.headers['id'] = userdetail.userid;
                }
            }

            return config;
        },
        error => Promise.reject(error)
    );
}

export default axiosInstance;



//////////////////
// WEBPACK FOOTER
// ./services/axiosins.js
// module id = 1208
// module chunks = 1